module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cS3so"))).then(() => parcelRequire('d0iPb'));